<template>
  <div>
    <!-- 客保统计 -->
    <div class="ins-header">
      <div class="ins-stat">
        <div class="ins-stat-num">
          <span>{{ statistics.total }}</span>个
          <div class="ins-stat-info">我的客保名额</div>
        </div>
        <img :src="blue">
      </div>
      <div class="ins-stat">
        <div class="ins-stat-num">
          <span>{{ statistics.no_open }}</span>个
          <div class="ins-stat-info">我未开户产品数(含开户中)</div>
        </div>
        <img :src="purple">
      </div>
      <div class="ins-stat">
        <div class="ins-stat-num">
          <span>{{ statistics.left_over }}</span>个
          <div class="ins-stat-info">我的剩余客保名额</div>
        </div>
        <img :src="green">
      </div>
    </div>
    <!-- 我的客保 -->
    <div>
      <CompoundQuery
        ref="query"
        @search="handleSearch"
      />
      <div v-if="list.length > 0">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="ins-item" 
        >
          <div class="ins-item-header">
            <div class="ins-item-header-left">
              <img
                v-if="item.icon_url"
                :src="item.icon_url"
              >
              <i
                v-else
                class="crm-icon-box ins-default"
              />
              <span
                style="cursor: pointer"
                @click="showDetail(item)"
              >
                {{ item.product_name }}
              </span>  
            </div>
            <div>
              <Button
                type="primary"
                @click="showDetail(item)"
              >
                查看详情
              </Button>
              <Button
                @click="exportPublic(item)"
              >
                释放到公海
              </Button>
            </div>
          </div>

          <Info :dataSource="item" />
        </div>
      </div>

      <Empty
        v-else
        style="margin-bottom: 20px"
        tips="没有数据"
      />
  
      <Pagination
        style="float: right"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { Button, Pagination } from 'element-ui';

import Info from './components/Info';
import CompoundQuery from './components/CompoundQuery';
import Empty from '@/components/Empty';

import requestMixin from './mixins/request';
import purple from '@/assets/image/insurance/purple@2x.png';
import blue from '@/assets/image/insurance/blue@2x.png';
import green from '@/assets/image/insurance/green@2x.png';

export default {
  components: {
    Button,
    Pagination,
    Info,
    CompoundQuery,
    Empty,
  },

  mixins: [requestMixin],

  data() {
    return {
      statistics: {},
      purple,
      blue,
      green,
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
    };
  },

  created() {
    this.customerMyStatistics();
    this.customerMyCustomerProtected();
  },

  methods: {
    handleSearch(params) {
      this.page = 1;
      this.customerMyCustomerProtected(params);
    },

    handleSizeChange(size) {
      this.pageSize = size;
      const params = this.$refs.query.getParams();
      this.customerMyCustomerProtected(params);
    },

    handleCurrentChange(current) {
      this.page = current;
      const params = this.$refs.query.getParams();
      this.customerMyCustomerProtected(params);
    },

    exportPublic(item) {
      const title = `请确认是否释放 <br/>【${item.product_name}】？`;
      this.$confirm(title, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确认，释放',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.exportToPublic(item);
      });
    },

    showDetail(item) {
      if (!item.customer_id) return;
      const router = this.$router.resolve({
        path: '/advertiser-manage/detail',
        query: {
          customerId: item.customer_id,
          type: '1',
          owner: item.user_id,
        },
      });
      window.open(router.href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.ins {
  &-default {
    width: 24px;
    height: 24px;
    background: rgba(220, 223, 230, 1);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-right: 8px;
  }

  &-header {
    display: flex;
    margin-bottom: 32px;
  }

  &-stat {
    width: 254px;
    height: 90px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(32, 45, 112, 0.1),
      0px 0px 2px 0px rgba(32, 45, 112, 0.04);
    border-radius: 8px;
    margin-right: 40px;
    display: flex;
    font-size: 14px;

    &-num {
      flex: 1;
      margin: 8px 0 0 16px;

      & > span {
        font-size: 36px;
        margin-right: 6px;
      }
    }

    &-info {
      font-weight: 400;
      color: rgba(144, 147, 153, 1);
    }

    & > img {
      width: 71px;
    }
  }

  &-item {
    box-sizing: border-box;
    padding: 28px;
    width: 100%;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(220, 223, 230, 1);
    margin-bottom: 24px;

    &-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 32px;

      &-left {
        display: flex;
        align-items: center;

        & > img {
          width: 24px;
          margin-right: 8px;
        }

        & > span {
          font-size: 24px;
          color: #2f9eff;
        }
      }
    }
  }
}
</style>